export enum EnvironmentalStatus {
    DEMO = '1001',
    PRODUCTION = '1002',
    DEVELOPMENT = '1003',
  }